export interface ComicArticle {
  id: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  shortDescription: string;
  rating: number;
  views: number;
  updatedDate: string;
  chapters: number;
  tags: string[];
  featured: boolean;
  trending: boolean;
  newRelease: boolean;
  content: string;
  seoTitle: string;
  seoDescription: string;
}

export interface ComicCategory {
  slug: string;
  name: string;
  description: string;
  count: number;
  icon: string;
}

export const comicCategories: ComicCategory[] = [
  { slug: 'romance', name: '恋爱漫画', description: '甜蜜浪漫的韩国恋爱故事，感受心动的瞬间', count: 128, icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', description: '穿越异世界，探索魔法与剑的奇幻大陆', count: 96, icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', description: '激烈战斗，燃爆你的肾上腺素', count: 84, icon: 'ri-fire-line' },
  { slug: 'thriller', name: '悬疑惊悚', description: '扣人心弦的悬疑故事，真相等你揭晓', count: 53, icon: 'ri-ghost-line' },
  { slug: 'comedy', name: '搞笑日常', description: '轻松幽默的日常，笑到停不下来', count: 67, icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情人生', description: '深刻感人的剧情，触动心灵的共鸣', count: 72, icon: 'ri-movie-line' },
  { slug: 'bl', name: 'BL漫画', description: '高人气BL作品，细腻情感刻画', count: 110, icon: 'ri-star-line' },
  { slug: 'completed', name: '已完结', description: '一口气看完的完结佳作', count: 45, icon: 'ri-check-double-line' },
];

export const comicArticles: ComicArticle[] = [
  {
    id: 'secret-classroom',
    title: '秘密教室',
    author: '朴智恩',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20school%20uniform%20standing%20near%20classroom%20window%20with%20cherry%20blossoms%20falling%2C%20soft%20pastel%20color%20palette%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20portrait%20orientation%2C%20warm%20lighting%2C%20beautiful%20composition&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    description: '在高中最后一年的秘密教室里，两个截然不同世界的人相遇了。学霸少女和不良少年，在放学后的秘密教室里展开了一段甜蜜又刺激的恋情。',
    shortDescription: '学霸少女与不良少年的秘密恋情，在放学后的教室里悄然绽放',
    rating: 4.8,
    views: 1280000,
    updatedDate: '2026-08-03',
    chapters: 87,
    tags: ['校园', '恋爱', '甜蜜', '成长'],
    featured: true,
    trending: true,
    newRelease: false,
    content: '<h3>第一话：命运的相遇</h3><p>阳光透过教室的窗户洒进来，金多美又一次在放学后留了下来。作为全校排名第一的学霸，她习惯了空无一人的教室——直到那天，门被推开，走进来的是全校闻名的校霸，韩志浩。</p><p>"你怎么在这里？"多美警惕地看着他。</p><p>志浩耸耸肩，嘴角扯出一个痞气的笑："我也想找个安静的地方。"</p><p>这就是一切的开始。在那个无人知晓的秘密教室里，两个从不同世界来的人，开始了他们独一无二的课后时光。</p><p>日子一天天过去，多美发现志浩并不像传闻中那样可怕。他会安静地坐在窗边画画，会在她解题遇到困难时不经意地给出提示，会在下雨天把唯一一把伞留给她。</p><p>而志浩也发现，这个看似冷漠的学霸少女，其实有着一颗温暖而敏感的心。她会在他睡着时轻轻给他披上外套，会在他被别人误解时第一个站出来说话。</p><p>他们约定：这个教室，是只属于他们两个人的秘密。没有人知道，在这里，两颗心正在悄悄靠近。</p>',
    seoTitle: '秘密教室 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《秘密教室》在线阅读：学霸少女与不良少年在放学后的秘密教室里展开的甜蜜恋情。朴智恩倾情创作，已更新至87话，校园恋爱题材必看推荐。',
  },
  {
    id: 'dragon-descendant',
    title: '龙裔',
    author: '李明浩',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20male%20warrior%20with%20dragon%20scales%20on%20skin%20holding%20a%20sword%20in%20medieval%20fantasy%20setting%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20golden%20and%20crimson%20tones&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    description: '一个被遗弃的龙族后裔，在人类世界隐姓埋名。当古老的龙族力量在他体内觉醒，他必须面对自己的宿命，守护这个世界不被黑暗吞噬。',
    shortDescription: '龙族后裔觉醒宿命之力，开启史诗级冒险旅程',
    rating: 4.9,
    views: 2150000,
    updatedDate: '2026-08-02',
    chapters: 156,
    tags: ['奇幻', '冒险', '龙族', '热血'],
    featured: true,
    trending: true,
    newRelease: false,
    content: '<h3>序章：被遗忘的血脉</h3><p>在遥远的东方大陆，龙族的传说从未断绝。人们说，龙族早已灭绝，只存在于古老的神话之中。</p><p>但他们错了。</p><p>崔允浩从小就知道自己与众不同。他的体温比常人高，受伤后的愈合速度快得惊人，偶尔在梦中，他能听到远古的龙吟。</p><p>二十岁生日那天，一切都变了。他的皮肤上浮现出龙鳞的纹路，双眼中燃起了金色的火焰。潜藏在血脉中的龙族之力，终于觉醒。</p><p>一位神秘的老者找到了他："孩子，你是最后的龙裔。黑暗正在蔓延，世界需要你的力量。"</p><p>从此，允浩踏上了探索自身力量的旅程。他遇见了同样拥有特殊能力的伙伴们——操控冰霜的少女、掌控雷电的剑客、预知未来的盲眼先知。他们的目标是找到散落在世界各处的龙族遗物，阻止黑暗之神的降临。</p>',
    seoTitle: '龙裔 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《龙裔》在线阅读：龙族后裔觉醒宿命之力，开启史诗冒险。李明浩创作的奇幻大作，已更新至156话，热血奇幻类必看推荐。',
  },
  {
    id: 'office-romance',
    title: '办公室恋人',
    author: '郑秀晶',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20man%20and%20beautiful%20woman%20in%20business%20attire%20sharing%20a%20tender%20moment%20in%20modern%20office%20with%20city%20skyline%20through%20window%2C%20romantic%20atmosphere%2C%20anime%20style%2C%20clean%20simple%20background%2C%20warm%20evening%20light&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    description: '29岁的职场女性林智秀，事业有成但感情空白。新来的上司竟然是她大学时代的初恋。在高压的职场环境中，两人重新点燃了旧日的火花。',
    shortDescription: '职场女性与初恋上司的办公室恋情，事业与爱情的双重挑战',
    rating: 4.7,
    views: 980000,
    updatedDate: '2026-08-04',
    chapters: 62,
    tags: ['职场', '恋爱', '成熟', '都市'],
    featured: false,
    trending: true,
    newRelease: true,
    content: '<h3>第一话：新来的上司</h3><p>林智秀盯着电脑屏幕，手指在键盘上飞速敲击。作为正元集团的市场部主管，她习惯了高压的工作节奏和加不完的班。</p><p>"各位同事，这位是新上任的营销总监——姜泰俊。"</p><p>智秀抬起头，手中的咖啡差点掉在桌上。站在她面前的，是她大学时代暗恋了四年的学长，姜泰俊。他看起来比当年更加成熟帅气，一双深邃的眼眸正看向她。</p><p>"好久不见，智秀。"他微笑着，声音低沉而有磁性。</p><p>周围的同事都用好奇的目光看着他们，智秀感到自己的脸在发烫。</p><p>从那天起，一切都不一样了。曾经的初恋成了每天都要面对的上司。会议室里的眼神交汇，茶水间的偶然相遇，加班的夜晚里两人独处的时光——旧日的情愫在钢筋水泥的写字楼里慢慢复苏。</p>',
    seoTitle: '办公室恋人 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《办公室恋人》在线阅读：职场女性与初恋上司的甜蜜恋情，郑秀晶倾情创作，已更新至62话，都市恋爱题材推荐。',
  },
  {
    id: 'shadow-hunter',
    title: '暗影猎人',
    author: '金泰亨',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cool%20male%20fighter%20in%20black%20tactical%20outfit%20wielding%20daggers%20in%20urban%20night%20setting%20with%20neon%20lights%2C%20action%20pose%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20dark%20and%20moody%20atmosphere&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    description: '在首尔的暗影中，有一群被称为"猎人"的存在。他们猎杀隐藏在人类社会中的超自然生物。主角韩宇镇在一次意外中觉醒了猎人之力，从此卷入了这场永无止境的暗影战争。',
    shortDescription: '都市超自然猎人的暗影战争，动作场面炸裂',
    rating: 4.8,
    views: 1890000,
    updatedDate: '2026-08-01',
    chapters: 128,
    tags: ['动作', '超自然', '都市', '战斗'],
    featured: true,
    trending: false,
    newRelease: false,
    content: '<h3>序章：暗影中的世界</h3><p>首尔，凌晨两点。大多数市民早已沉入梦乡，但对于韩宇镇来说，一天才刚刚开始。</p><p>他从高楼一跃而下，黑色的风衣在夜风中猎猎作响。手中的双刀反射着霓虹灯的光——这是他作为"暗影猎人"的标志。</p><p>"南区第三街巷，三级异常生物，疑似血族。"耳麦中传来指令。</p><p>宇镇嘴角微微上扬。来到现场，他看到了目标——一个伪装成人类的血族，正在小巷中跟踪一个夜归的女子。</p><p>"喂，这么晚了还不回家可不好。"宇镇落在血族面前，双刀交叉于胸前。</p><p>血族露出獠牙，眼中闪过红光："猎人...多管闲事!"</p><p>战斗在瞬间爆发。刀光剑影之中，宇镇的猎人之力完全释放。那是他从一次濒死体验中觉醒的能力——暗影操控。他能化身为影，在黑暗中自由穿行，让敌人防不胜防。</p>',
    seoTitle: '暗影猎人 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《暗影猎人》在线阅读：都市超自然猎人的暗影战争，金泰亨创作的动作神作，已更新至128话，热血动作迷必追。',
  },
  {
    id: 'missing-puzzle',
    title: '失踪的拼图',
    author: '尹素熙',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20woman%20holding%20a%20puzzle%20piece%20with%20shadowy%20figures%20in%20background%2C%20psychological%20thriller%20mood%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20cold%20blueish%20gray%20tones&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    description: '刑警崔敏雅接手了一起连环失踪案。所有失踪者唯一的共同点是——他们都收到过一块神秘的拼图碎片。随着调查深入，她发现自己也成为了这场致命游戏的一部分。',
    shortDescription: '连环失踪案背后的致命拼图游戏，悬疑感拉满',
    rating: 4.6,
    views: 1430000,
    updatedDate: '2026-08-03',
    chapters: 74,
    tags: ['悬疑', '推理', '犯罪', '心理'],
    featured: false,
    trending: true,
    newRelease: false,
    content: '<h3>第一话：第一块碎片</h3><p>江南警署的重案组办公室里，崔敏雅盯着白板上钉着的七张照片。七个人，七张面孔，唯一的共同点是——他们都失踪了。</p><p>"敏雅，又收到一块碎片。"同事递来一个透明证物袋。</p><p>里面是一片不规则的拼图碎片，上面用红色墨水写着一个数字：8。</p><p>第八个受害者即将出现。</p><p>敏雅心中的不安越来越强烈。她仔细研究了前面七个失踪者的背景：有公司职员、大学生、外卖骑手、咖啡师……他们的人生轨迹几乎没有任何交集。但敏雅发现了一个细节——每个失踪者都在失踪前三天收到过一块拼图碎片。</p><p>拼图在慢慢完整，而真相却越来越扑朔迷离。</p><p>当晚，敏雅回到家，打开信箱，整个人僵在了原地。信箱里静静地躺着一个信封，里面是一片拼图碎片——数字是：9。</p><p>她成了下一个目标。</p>',
    seoTitle: '失踪的拼图 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《失踪的拼图》在线阅读：刑警追踪连环失踪案，自己却成为目标。尹素熙创作悬疑力作，已更新至74话，推理迷必看。',
  },
  {
    id: 'daily-bread',
    title: '日常面包',
    author: '赵恩智',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cute%20baker%20girl%20in%20bakery%20with%20flour%20on%20her%20nose%20surrounded%20by%20cats%20and%20bread%2C%20warm%20and%20cozy%20slice%20of%20life%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20soft%20golden%20lighting&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    description: '独自经营面包店的女孩金素拉，每天都有奇怪的客人光临。从会说话的猫咪到伪装成人类的外星人，素拉的日常生活从来不会无聊。轻松治愈的搞笑日常！',
    shortDescription: '面包店女孩与奇怪客人们的搞笑日常，治愈系喜剧',
    rating: 4.5,
    views: 870000,
    updatedDate: '2026-08-04',
    chapters: 45,
    tags: ['搞笑', '日常', '治愈', '萌宠'],
    featured: false,
    trending: false,
    newRelease: true,
    content: '<h3>第一话：会说话的猫咪客人</h3><p>清晨五点，晨光透过面包店的玻璃窗洒进来。金素拉熟练地将面团送入烤箱，空气中弥漫着黄油和小麦的香气。</p><p>"叮铃"——门口的风铃响了。</p><p>"欢迎光临！"素拉抬起头，却看到了一个不寻常的客人——一只三花猫正端坐在柜台前。</p><p>"老板，来一个菠萝包，要刚出炉的。"猫咪开口说话。</p><p>素拉眨眨眼，又眨眨眼。她放下手中的面团，深吸一口气："好的，请稍等。"</p><p>——毕竟，在她的面包店里，什么事情都不算奇怪。</p><p>这就是金素拉的日常。她的"日出面包店"位于首尔一条不起眼的小巷里，却吸引了各种奇奇怪怪的客人。有来自仙女座的外星人（伪装成上班族），有活了三百年的狐狸精（假装是大学生），还有能预知未来的流浪狗（经常来蹭吃蹭喝）。</p><p>但素拉不在乎。只要客人们喜欢她的面包，一切都好。</p>',
    seoTitle: '日常面包 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《日常面包》在线阅读：面包店女孩的搞笑治愈日常，赵恩智创作，已更新至45话，轻松幽默的治愈系必看推荐。',
  },
  {
    id: 'time-rewind',
    title: '时光倒流',
    author: '朴善英',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20melancholic%20woman%20looking%20at%20a%20pocket%20watch%20with%20clock%20imagery%20in%20background%2C%20emotional%20drama%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20soft%20sepia%20tones&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    description: '四十岁的李瑞妍收到了一份神秘礼物——一只可以让时光倒流的怀表。她回到了二十年前，见到了年轻时的自己，也见到了那个她一生中最爱的人。这是一场关于遗憾与救赎的旅程。',
    shortDescription: '中年女性回到过去，弥补一生遗憾的感人故事',
    rating: 4.9,
    views: 1670000,
    updatedDate: '2026-07-30',
    chapters: 103,
    tags: ['剧情', '时光', '感人', '人生'],
    featured: true,
    trending: true,
    newRelease: false,
    content: '<h3>第一话：四十年的人生</h3><p>李瑞妍站在浴室的镜子前，看着镜中四十岁的自己。细纹爬上了眼角，曾经乌黑的长发中夹杂着银丝。她是一个成功的律师，拥有令人羡慕的事业，但她的人生却有一个永远无法弥补的遗憾。</p><p>二十年前的那个雨天，她选择了工作而不是去见他最后一面。那个人——她一生中最爱的人，在那天离开了这个世界。</p><p>生日那天，瑞妍收到了一个匿名包裹。打开后，里面是一只精致的古董怀表，附着一张纸条："转动它，你可以回到过去。但记住——改变过去，未来也会改变。"</p><p>瑞妍以为是个玩笑，但当她无意中转动了怀表的发条，周围的一切开始扭曲。天旋地转之后，她发现自己站在二十年前的街头。街角的那家老咖啡馆还在，而透过窗户，她看到了那个熟悉的身影——年轻时的他。</p><p>这一次，她不会再错过。</p>',
    seoTitle: '时光倒流 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《时光倒流》在线阅读：中年女性回到过去弥补一生遗憾，朴善英创作感人剧情，已更新至103话，催泪神作推荐。',
  },
  {
    id: 'blood-contract',
    title: '血之契约',
    author: '崔胜铉',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20vampire%20noble%20in%20luxurious%20black%20suit%20with%20red%20eyes%20holding%20a%20contract%2C%20dark%20gothic%20atmosphere%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20deep%20crimson%20and%20black%20tones&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    description: '为了拯救病危的妹妹，普通女孩韩宥真与一个神秘的血族贵族签订了契约。她成为他的"血仆"，代价是付出自己的鲜血。但她不知道，这份契约背后隐藏着一个关于爱与牺牲的古老诅咒。',
    shortDescription: '少女为救妹妹与血族签订契约，黑暗中的禁忌之恋',
    rating: 4.7,
    views: 1350000,
    updatedDate: '2026-08-02',
    chapters: 91,
    tags: ['吸血鬼', '契约', '黑暗', '爱情'],
    featured: false,
    trending: true,
    newRelease: false,
    content: '<h3>第一话：绝望中的契约</h3><p>医院消毒水的气味让宥真想要呕吐。她站在重症监护室的玻璃窗外，看着病床上插满管子的妹妹。医生的话还在耳边回响："最多三个月...除非有奇迹。"</p><p>宥真已经花光了所有积蓄，借遍了所有能借的人。她绝望了。</p><p>那晚，一个男人出现在医院走廊。他穿着黑色西装，苍白的面容透着不属于这个时代的气质。红色的眼眸在黑暗中微微发光。</p><p>"我可以救你的妹妹，"他的声音低沉而迷人，"代价是——你的血。"</p><p>宥真以为自己在做梦。但当男人伸出手，她看到他的手背上浮现出复杂的血色纹路——那是血族的契约纹。</p><p>"签下契约，你妹妹会恢复健康。而你，将成为我的血仆。这是等价交换。"</p><p>宥真看了一眼病房中的妹妹，咬了咬嘴唇。她接过男人递来的羽毛笔，在契约书的最后一页签下了自己的名字。笔尖触纸的瞬间，她感到一阵刺痛——契约已成。</p>',
    seoTitle: '血之契约 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《血之契约》在线阅读：少女为救妹妹与血族签订契约。崔胜铉创作，已更新至91话，黑暗浪漫题材强推。',
  },
  {
    id: 'bl-spring-breeze',
    title: '春风十里',
    author: '李在旭',
    category: 'bl',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20two%20handsome%20young%20men%20in%20spring%20setting%20with%20cherry%20blossoms%2C%20tender%20romantic%20mood%2C%20BL%20genre%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20soft%20pink%20and%20white%20tones&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    description: '大学生郑河俊在新学期的第一堂课上遇到了一个让他心动的男生——美术系的插班生金施温。从春天开始，到春天结束，一段美好而心酸的校园恋歌。',
    shortDescription: '校园BL纯爱故事，从春天开始的美好恋歌',
    rating: 4.8,
    views: 2200000,
    updatedDate: '2026-08-03',
    chapters: 68,
    tags: ['BL', '校园', '纯爱', '青春'],
    featured: false,
    trending: true,
    newRelease: false,
    content: '<h3>第一话：春风拂面</h3><p>三月，弘益大学的校园里，樱花刚刚绽放。</p><p>郑河俊抱着画板穿过校园，心里抱怨着通识课选错了教室。当他气喘吁吁地推开后门时，讲台上的教授正在点名。</p><p>"...金施温同学？金施温在吗？"</p><p>"到。"一个清朗的声音从河俊旁边传来。</p><p>河俊侧过头，看到了一张让他心跳漏了一拍的脸。那个男生坐在窗边，春日的阳光透过玻璃洒在他浅棕色的头发上，睫毛的阴影落在白皙的脸颊上。他正在素描本上画着什么——是窗外那棵盛开的樱花树。</p><p>金施温似乎感觉到了目光，抬起头，与河俊的视线相遇。他微微一愣，然后露出了一个浅浅的笑容。</p><p>那是河俊人生中第一次感受到"一见钟情"这个词的真正含义。</p><p>春风从窗外吹进来，带着花瓣和青草的气息。在这个春天开始的教室里，一段恋歌的序曲悄然奏响。</p>',
    seoTitle: '春风十里 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《春风十里》在线阅读：校园BL纯爱故事，李在旭创作，已更新至68话，BL爱好者口碑推荐。',
  },
  {
    id: 'chef-king',
    title: '厨王之路',
    author: '姜东元',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20energetic%20chef%20in%20professional%20kitchen%20holding%20a%20pan%20with%20flames%2C%20cooking%20action%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20vibrant%20warm%20colors&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    description: '完全没有料理天赋的年轻人车太贤，阴差阳错进入了韩国最顶级的烹饪学校。在一群天才厨师中间，他用搞笑的方式不断成长，最终走上了厨王之路。',
    shortDescription: '料理废材闯入顶级厨校，搞笑热血的厨王成长之路',
    rating: 4.6,
    views: 1120000,
    updatedDate: '2026-07-28',
    chapters: 115,
    tags: ['美食', '搞笑', '成长', '热血'],
    featured: false,
    trending: false,
    newRelease: false,
    content: '<h3>第一话：史上最差厨艺</h3><p>"车太贤！你又在厨房搞什么！"</p><p>消防车的警铃声在首尔烹饪艺术学院的宿舍楼外响起。太贤站在冒着浓烟的厨房里，手里拿着一只烧成炭的煎锅，脸上全是面粉。</p><p>"我...我只是想煎个鸡蛋..."</p><p>教导主任气得脸色发青："你是我们学校建校五十年来，唯一一个能把煎鸡蛋变成火灾的学生！"</p><p>太贤低着头，心里委屈极了。他本来就不是自己考进来的——是在街头美食节上被校长看中，说什么"你的眼神里有一股对美食的执着"，就这么被特招进了这所韩国最顶级的烹饪学校。</p><p>问题是，他对料理的热爱是真的，但他的天赋——全是负的。</p><p>切菜切到手，煮面煮成糊，连最简单的饭都会煮成锅巴。同学们都叫他"厨房毁灭者"。</p><p>但太贤没有放弃。他要证明，即使没有任何天赋，靠努力也能成为真正的厨王！</p>',
    seoTitle: '厨王之路 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《厨王之路》在线阅读：料理废材的搞笑成长之路，姜东元创作，已更新至115话，美食搞笑热血推荐。',
  },
  {
    id: 'ghost-detective',
    title: '幽灵侦探',
    author: '郑俊英',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20trench%20coat%20with%20ghostly%20translucent%20figure%20beside%20him%20in%20rainy%20noir%20cityscape%2C%20supernatural%20mystery%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20dark%20moody%20atmosphere&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    description: '因公殉职的刑警韩宰赫，死后成为了一个能看见幽灵的"特殊侦探"。他能与亡灵对话，破解活人无法触及的案件。但每一个案件背后，都隐藏着更深的人性秘密。',
    shortDescription: '亡灵侦探破解活人破不了的悬案，超自然推理',
    rating: 4.7,
    views: 1560000,
    updatedDate: '2026-08-01',
    chapters: 82,
    tags: ['悬疑', '超自然', '推理', '幽灵'],
    featured: true,
    trending: false,
    newRelease: false,
    content: '<h3>第一话：死亡不是终点</h3><p>韩宰赫记得自己是怎么死的。一颗子弹穿过胸口，温热的血液浸透了衬衫。最后的画面是搭档惊恐的脸，和凶手消失在黑暗中的背影。</p><p>然后，他醒了过来。不——准确地说，他的灵魂醒了过来。</p><p>他发现自己站在自己的尸体旁边，而周围的人都看不见他。但有一个例外——那些同样死去的人。</p><p>"你能看见我？"一个被谋杀的女孩的灵魂怯生生地问。</p><p>"是的。告诉我，是谁杀了你？"</p><p>这就是幽灵侦探韩宰赫的新生活。他不能触碰活人，不能拿起任何物体，但他可以和亡灵对话——大多数案件唯一的目击证人。</p><p>他在阴间和阳间的交界处行走，为那些无法安息的灵魂寻找真相，也为自己寻找那个杀死了他的凶手。</p>',
    seoTitle: '幽灵侦探 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《幽灵侦探》在线阅读：亡灵侦探破解活人无法触及的悬案。郑俊英创作超自然推理力作，已更新至82话。',
  },
  {
    id: 'mermaid-tears',
    title: '人鱼之泪',
    author: '金荷娜',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20mermaid%20with%20long%20flowing%20hair%20and%20shimmering%20tail%20in%20underwater%20scene%20with%20bubbles%20and%20light%20rays%2C%20fantasy%20romance%2C%20anime%20style%20artwork%2C%20clean%20simple%20background%2C%20ethereal%20turquoise%20and%20pearl%20tones&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    description: '深海人鱼公主阿莉亚的眼泪能治愈一切疾病。当人类的渔船侵入她的家园，她在暴风雨中救起了一个溺水的少年。一个人类与人鱼的禁忌之恋，在深蓝的海底缓缓展开。',
    shortDescription: '人鱼公主与人类少年的禁忌之恋，深海奇幻童话',
    rating: 4.5,
    views: 760000,
    updatedDate: '2026-08-04',
    chapters: 38,
    tags: ['人鱼', '奇幻', '爱情', '童话'],
    featured: false,
    trending: false,
    newRelease: true,
    content: '<h3>第一话：深海之歌</h3><p>在人类无法触及的深海深处，有一个由珊瑚和珍珠建成的王国——亚特兰。</p><p>阿莉亚是亚特兰最小的公主，拥有一条闪闪发光的银色鱼尾和一头如海藻般柔顺的长发。她的歌声能让鱼群起舞，她的眼泪能治愈一切伤病。</p><p>但人鱼的眼泪是极其珍贵的——每流一滴泪，人鱼就会失去一年的寿命。</p><p>那天，暴风雨席卷了海面。一艘人类渔船在巨浪中翻覆，一个少年落入了冰冷的海水。阿莉亚在珊瑚丛中看到了他——他紧闭着双眼，正在慢慢下沉。</p><p>人鱼族的古老法则第一条：永远不要接近人类。</p><p>但阿莉亚还是游了过去。她抱住少年，将他托出海面，推到了一块礁石上。少年的睫毛颤动了一下——那是阿莉亚第一次看到人类的眼睛。</p><p>她没有注意到，一滴晶莹的泪珠从她的眼角滑落，落入了少年的唇间。与此同时，她的尾鳍感到一阵刺痛。</p><p>契约——在那一刻，被悄然书写。</p>',
    seoTitle: '人鱼之泪 - 好看的韩漫推荐 - 韩漫网',
    seoDescription: '韩漫《人鱼之泪》在线阅读：人鱼公主与人类少年的深海禁忌之恋。金荷娜创作奇幻爱情故事，已更新至38话。',
  },
];

export const featuredComics = comicArticles.filter(c => c.featured);
export const trendingComics = comicArticles.filter(c => c.trending);
export const newReleaseComics = comicArticles.filter(c => c.newRelease);

export function getComicsByCategory(slug: string): ComicArticle[] {
  return comicArticles.filter(c => c.category === slug);
}

export function getComicById(id: string): ComicArticle | undefined {
  return comicArticles.find(c => c.id === id);
}

export function getCategoryBySlug(slug: string): ComicCategory | undefined {
  return comicCategories.find(c => c.slug === slug);
}